import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller('CreateProposalStageTwoCtrl', CreateProposalStageTwoCtrl);

    function CreateProposalStageTwoCtrl($scope, createProposalService) {
        var vm = this;

        vm.submit = submit;
        vm.INTENTION = createProposalService.INTENTION;
        vm.networkPoint = {};
        vm.tsoConfig = {};

        init();

        function init() {
            vm.ui = {};
            vm.data = createProposalService.getStageTwo();
            vm.networkPoint =
                createProposalService.getStageOne().selectedNetworkPoint;
            vm.tsoConfig = createProposalService.getStageOne().tsoConfig;
            vm.isEditing = !!createProposalService.getStageFive().id;
        }

        function submit(form: ng.IFormController) {
            if (!form.$valid) {
                $scope.wizard.goToTop();
                return false;
            }
            createProposalService.setStageTwo(vm.data);
            $scope.wizard.goToNextStage();
        }

        function getSecondaryType() {
            if (vm.data.intention) {
                return vm.data.intention === 'PROPOSAL_TO_SELL'
                    ? 'offer'
                    : 'request';
            }
            return 'N/A';
        }
    }
})();
